module.exports = __webpack_public_path__ + "static/img/AB4338769.5a469142.jpg";